<!-- <ion-header>
    <ion-navbar>
        <ion-label text-right class="primary" *ngIf="type === 'Results'">
            {{ 'MAIN_TAB_RESULTS' | translate | uppercase }} {{ eventType | translate | uppercase }}
        </ion-label>
        <ion-label text-right class=" primary" *ngIf="type === 'Events'">
            {{ 'MAIN_TAB_EVENTS' | translate | uppercase }} {{ eventType | translate | uppercase }}
        </ion-label>
    </ion-navbar>
</ion-header> -->

<ion-content>
    <!-- NEW MENU -->

    <ion-list>
        <div *ngFor="let complex of eventsComplex; index as i">
            <ion-item-divider class="list-header" color="light">
                <img class="list-header-img" src='../../../assets/imgs/sport_types/{{ eventType }}.png'>
                <div class="primary">{{ complex.category }}</div>
            </ion-item-divider>
            <button ion-item class="list-item" *ngFor="let event of arrayOf(complex.event, i)"
                (click)="onEventLoad(event)">
                <h4>{{ event.dateFormatted }}</h4>
                <h4 class="padding-left" text-nowrap>{{ event.eventName }}</h4>
            </button>
            <ion-item style="text-align: center;">
                <!-- <div [className]="isFirstPage(i)? 'btn_disabled' : 'sign_lt'" text-center
                    (click)="isFirstPage(i)? null : prevPage(i)">
                    {{ 'SIGN_LEFT' | translate }}
                </div>
                <div [className]="isLastPage(complex.event.length, i)? 'btn_disabled' : 'sign_mt'" text-center
                    padding-left (click)="isLastPage(complex.event.length, i)? null : nextPage(i)">
                    {{ 'SIGN_RIGHT' | translate }}
                </div> -->
                <button ion-button (click)="onMorePress(i)" *ngIf="type === 'Events'">
                    {{ 'GLOBAL_MORE_EVENTS' | translate | uppercase }}</button>
                <button ion-button (click)="onMorePress(i)" *ngIf="type !== 'Events'">
                    {{ 'GLOBAL_MORE_RESULTS' | translate | uppercase }}</button>
                <!-- <div item-end no-padding class="button_lastrow" (click)="onMorePress(i)">
                    {{ 'GLOBAL_MORE' | translate | uppercase}}</div> -->
            </ion-item>
        </div>
    </ion-list>
</ion-content>